// extracted by mini-css-extract-plugin
export default {"AddressLabel":"AddressField_AddressLabel__uFzoP"};